// Booking-type rules shared by the staff booking screens (2026-10-04).
//
// MAINTENANCE-LIKE TYPES: a per-booking net price typed by the office, no
// cleaners, no laundry/amenities, a single service line on the invoice.
// "Swimming Pool Maintenance" (type 14) is the second member; the screens
// look types up by NAME so nothing here hard-codes an id.
export const MAINTENANCE_TYPE_NAMES = ['Maintenance', 'Swimming Pool Maintenance'];
export const isMaintenanceTypeName = (name) => MAINTENANCE_TYPE_NAMES.includes(name);
export const maintenanceTypeIds = (bookingTypes) =>
  (bookingTypes || []).filter((t) => isMaintenanceTypeName(t.type)).map((t) => t.id);

// CUSTOM ADD-ONS: the office types the line's name and net price; it lands on
// the Zoho invoice under exactly that name. Every custom add-on is anchored to
// items row 1351 "Custom Service" (the Zoho item carries the 5% VAT); the
// name and rate travel on booking_addons.custom_name / custom_rate.
export const CUSTOM_ADDON_ITEM_ID = 1351;
export const CUSTOM_NAME_MAX = 100;

let customSeq = 0;
export const newCustomAddon = () => ({
  id: `custom-${Date.now()}-${++customSeq}`,
  custom: true,
  name: '',
  price: '',
  quantity: 1,
});

/** The shape POST/PUT /api/bookings expects for one selected add-on. */
export const addonPayload = (a) => (a.custom
  ? {
    item_id: CUSTOM_ADDON_ITEM_ID,
    custom_name: String(a.name || '').trim().slice(0, CUSTOM_NAME_MAX),
    custom_rate: Math.round((parseFloat(a.price) || 0) * 100) / 100,
    quantity: parseFloat(a.quantity) || 1,
  }
  : { item_id: a.id, quantity: a.quantity });

/** A custom row needs a name, a price of 0 or more and a positive quantity. */
export const customAddonsValid = (list) => (list || [])
  .filter((a) => a.custom)
  .every((a) => String(a.name || '').trim().length > 0
    && Number.isFinite(parseFloat(a.price)) && parseFloat(a.price) >= 0
    && parseFloat(a.quantity) > 0);

/** GET /api/bookings/addons/:id row → the form's selected_addons shape. */
export const assignedToForm = (a) => (a.is_custom
  ? { id: `custom-row-${a.id}`, custom: true, name: a.name, price: a.default_price, quantity: a.quantity || 1 }
  : { id: a.item_id, name: a.name, price: a.default_price, quantity: a.quantity || 1 });
